import type { Deferred } from '@patsnap/tahiti-core/utils/deferred';
import type { SpecificationEmbodimentOutlineModel } from '../models/specification-embodiment-outline-model';
import type { EmbodimentOutline } from '../apis/create-embodiment-outline-api';

export const SpecificationEmbodimentOutlineService = Symbol.for('SpecificationEmbodimentOutlineService');

export interface SpecificationEmbodimentOutlineService {
    creatingDeferred: Deferred<any> | undefined;
    model: SpecificationEmbodimentOutlineModel;

    /**
     * 进入
     */
    enter(): void;

    /**
     * 完成
     */
    finish(): void;

    /**
     * 中止
     */
    abort(): void;

    /**
     * 初始化实施例大纲
     */
    init(): Promise<void>;

    /**
     * 读取已有的实施例，跳过
     */
    pass(): Promise<void>;

    /**
     * 提交实施例大纲
     */
    submit(): Promise<void>;

    /**
     * 保存所有实施例大纲
     */
    save(): Promise<void>;

    /**
     * 追加实施例大纲
     */
    append(embodimentOutline: EmbodimentOutline): Promise<EmbodimentOutline>;

    /**
     * 删除实施例大纲
     */
    remove(embodimentOutline: EmbodimentOutline): Promise<void>;
}
